import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2px;
`;

const Text = styled.div`
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #2f3133;
`;

export default function Radio({ value, checked, onChange, children }) {
  return (
    <Wrapper onClick={onChange}>
      <input type="radio" value={value} checked={checked}></input>
      <Text>{children}</Text>
    </Wrapper>
  );
}
